"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableHeadline = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
exports.EditableHeadline = function (_a) {
    var maxLength = _a.maxLength, originalTitle = _a.originalTitle, text = _a.text, onTitleChange = _a.onTitleChange, _b = _a.onTitleEditingCancel, onTitleEditingCancel = _b === void 0 ? noop_1.default : _b, _c = _a.onTitleEditingStart, onTitleEditingStart = _c === void 0 ? noop_1.default : _c;
    return (react_1.default.createElement(sdk_ui_kit_1.EditableLabel, { className: "s-editable-label s-headline", maxRows: 2, value: text, maxLength: maxLength, placeholder: originalTitle, onEditingStart: onTitleEditingStart, onSubmit: onTitleChange, onCancel: onTitleEditingCancel },
        react_1.default.createElement("span", null, text)));
};
//# sourceMappingURL=EditableHeadline.js.map